import { TaskSquare } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - RESULT ||============================== //

const Result: NavItemType = {
  id: 'group-result',
  title: 'Result',
  type: 'group',
  children: [
    {
      id: 'result',
      title: 'Result',
      type: 'item',
      url: '/result',
      icon: TaskSquare,
      breadcrumbs: false
    }
  ]
};

export default Result;
